
<template>
  <div class="clearfix main_center" v-loading.fullscreen.lock="loading">

    <div class="right-content clearfix busWinessRight">
      <pm-form-render v-if="customFormShow" ref="customFormRef" :filingCBtn="filingCBtn"></pm-form-render>
      <!--          <customForm-->
      <!--                  v-if="customFormShow"-->
      <!--                  ref="customFormRef"-->
      <!--                  :auditHisTable.sync="auditHisTable"-->
      <!--                  :entityId.sync="entityId"-->
      <!--                  :categoryCode.sync="categoryCode"-->
      <!--                  :filingCBtn="filingCBtn"-->
      <!--                  :baseURL.sync="baseURL">-->
      <!--          </customForm>-->

      <customFormOther v-if="customFormOtherShow" ref="customFormOtherRef" :auditHisTable.sync="auditHisTable"
                       :entityId.sync="entityId" :categoryCode.sync="categoryCode" :purchaserMode.sync="purchaserMode"
                       :nodeTitle.sync="nodeTitle" :filingCBtn="filingCBtn" :nodeCode.sync="nodeCode">
      </customFormOther>

      <!--  见证情况-->
<!--      <witnessStatusForm-->
<!--          v-if="witnessStatusFormList.indexOf(nodeCode) > -1 && areaBesidesCodeList.indexOf(stateData.orgInfo.regionCode) < 0"-->
<!--          ref="witnessStatusForm" :projectInfo="paramMap"></witnessStatusForm>-->

      <el-card class="box-card" v-if="!customFormShow && !customFormOtherShow"
               style="height: 700px;position: relative;margin-bottom: 10px">
        <emptyInfo v-if="groupList.length == 0" :emptyMsg="'暂无表单数据'"></emptyInfo>
      </el-card>
    </div>


    <div class="left-content busWinessLeft">
      <div class="left-navbar">
        <div class="pageInfo">
          <p class="title">系统标识码</p>
          <p>交易系统标识码<br> <span>{{ platformCode }}</span></p>
          <p>公共服务平台标识码<br> <span>{{ pubServicePlatCode }}</span></p>
        </div>
        <el-button type="primary" plain size="small" @click="viewDataDet()">查看项目数据</el-button>
        <el-button type="primary" size="small" @click="showAuditWindow(true, '通过')" v-show="filingCBtn">同意</el-button>
        <el-button type="primary" plain size="small" @click="showAuditWindow(false, '不通过')"
                   v-show="backCBtn">退回</el-button>
        <el-button type="primary" size="small" @click="expertPush()"
                   v-if="!backCBtn && !filingCBtn && evalcommitteeBuildId">补推</el-button>
        <el-button @click="back()" size="small">返回</el-button>
      </div>
    </div>

    <!-- auditForm.isPass?'是否将表单中的预警提醒进行【忽略】操作':'是否将表单中的预警提醒进行【处理】操作' -->
    <el-dialog title="意见栏" :visible.sync="dialogVisible" width="40%">
      <div class="dialogBox">
        <el-form ref="auditForm" :model="auditForm" label-width="90px" class="form">
          <el-form-item label="意见：" style="width:90%;">
            <el-input type="textarea" :rows="10" v-model="auditForm.suggest"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" class="backBtn">返回</el-button>
        <el-button type="primary" @click="auditProcess" style="margin-bottom:20px;">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import customForm from '@/components/customForm';
import emptyInfo from '@/components/empty-info';
import customFormOther from '@/components/customForm/customFormOther';
import { mapState } from "vuex";
import { tabsCloseCurrentHandle } from '@/utils/routeTab';



export default {
  components: {
    customForm,
    emptyInfo,
    customFormOther,

  },
  data() {
    return {
      id: "",
      baseURL: "",
      categoryCode: "",
      platformCode: "",
      pubServicePlatCode: "",
      tenderProjectType: '',
      tenderScope: '',
      customFormShow: true,
      nodeCode: "",
      nodeTitle: "",
      purchaserMode: "",// 采购方式
      customFormOtherShow: false,
      taskId: '',
      form: {
        id: '',
        historyid: '-1',
        processinstanceid: "",
        processinstancecreatedate: "",
        businessType: "",
        entityId: "",
        flowId: '',
        tenderProjectCode: '',
        bidSectionCode: '',
        projectCode: '',
        personHandle: 1,  //人工干预见证
        rejectCode: '',
      },
      listNav: ['项目信息', '中选信息', '附件信息'],
      auditForm: {
        isPass: null,
        suggest: ''
      },
      dialogVisible: false,
      auditHisTable: [], // 变更历史
      loading: false,
      user: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      processSubmit: false,
      customFormData: {},
      filingCBtn: false,
      backCBtn: false,
      dataId: 0,
      paramMap: {
        tenderProjectCode: '',
        bidSectionCode: '',
        projectCode: '',
        applyCode: "",
        idcard: "",
        categoryCode: "",
      },
      formId: '',
      groupList: [],
      formInfo: {},
      tableData: [],


      // 见证情况列表
      witnessStatusFormList: ['GC00001', 'GC00043', 'GC00003', 'GC00004', 'GC00044', 'GC00006', 'GC00025', 'GC00026', 'GC00027', 'GC00029', 'GC00039', 'GC00041', 'GC00040',],
      // 排除区域列表 阳新 大冶
      areaBesidesCodeList: ['420281', '420222'],
    }
  },

  filters: {

  },
  created() {
    const { evalcommitteeBuildId } = this.$route.query
    this.evalcommitteeBuildId = evalcommitteeBuildId && evalcommitteeBuildId != 'undefined' ? evalcommitteeBuildId : ''
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),
    businessType: function () {
      return this.form.businessType;
    },
    processinstanceid: function () {
      return this.form.processinstanceid;
    },
    entityId: function () {
      return this.form.entityId;
    },

  },

  activated() {
    // $route.query.id为首页通过 url跳转 带过来的参数
    this.id = (this.$route.query && this.$route.query.id) || (this.$route.params && this.$route.params.id) || '';
    this.purchaserMode = this.$route.query && this.$route.query.purchaserMode
    this.getDetailById();
  },

  methods: {
    //列表查看进来根据id查询详情
    getDetailById() {

      if (this.id) {

        // 查询基本信息及流程id
        this.$http.get('/businessFlowWitness/get?id=' + this.id).then(res => {
          if (res.data.code === '1') {

            this.form = { ...res.data.data }

            this.processSubmit = false;
            this.filingCBtn = false;
            this.backCBtn = false;
            const data = res.data.data
            this.paramMap.tenderProjectCode = data.tenderProjectCode || '';
            this.paramMap.bidSectionCode = data.bidSectionCode || data.businessCode || '';
            this.paramMap.projectCode = data.projectCode || '';
            this.paramMap.entityId = data.entityId || '';
            this.paramMap.datasetCode = data.datasetCode || '';
            if (this.paramMap.tenderProjectCode) {
              this.$http.get(`/tenderProject/getTenderProjectByCode?tenderProjectCode=${this.paramMap.tenderProjectCode}&busiType=${this.businessType}`).then(res2 => {
                if (res2.data.code === '1') {
                  this.platformCode = data.platformCode || '';
                  this.pubServicePlatCode = data.pubServicePlatCode || '';
                  this.tenderProjectType = res2.data.data.tenderProjectType || '';
                  this.tenderScope = res2.data.data.tenderScope || '';
                }
              })
            }

            this.getFormIdByFlowid(res.data.data.flowId);

            this.getFlow(this.processinstanceid);

            this.getAuditHisList()



          }
        })

      } else {
        this.$router.push({
          name: 'home'
        })
      }

    },

    getAuditHisList() {
      // 查询见证记录数据
      this.$http.get('/auditHistory/getListAudit?entityId=' + this.form.entityId).then(res => {
        if (res.data.code === '1') {
          this.auditHisTable = res.data.data;
        } else {
          this.auditHisTable = [];
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      })
    },

    // 返回
    back() {
      tabsCloseCurrentHandle();
      if (this.$route.query.evalcommitteeBuildId) {
        this.$router.push({
          name: 'expertExtract',
        })
        return
      }
      this.$router.push({
        name: 'busWitness_list_' + this.businessType,
      })

    },
    viewDataDet() {
      console.log(this.form)
      let paramMap = {
        tenderProjectCode: this.form.tenderProjectCode || '',
        bidSectionCode: this.form.bidSectionCode || '',
        bidSectionId: this.form.bidSectionId || '',
        tradePlatfBidSectionId: this.form.tradePlatfBidSectionId || '',
        projectCode: this.form.projectCode || '',
        bidSectionName: this.form.bidSectionName || '',
        applyCode: "",
        idcard: "",
      }
      window.sessionStorage.setItem("witnessHisDetailParamMap", JSON.stringify(paramMap))
      this.$router.push({
        name: "businessWitnessHis_detail",
        params: { paramMap: paramMap },
        query: {
          businessType: this.businessType,
          angleType: this.form.angleType,
          purchaserMode: this.form.purchaserMode || '',
          nodeCode: "GC00040"
        },
      });
    },
    showAuditWindow(isPass, msg) {
      // var vaildflag = true
      // if (this.$refs.witnessStatusForm) {
      //   this.$refs.witnessStatusForm.detail.situationDetailList.forEach(item => {
      //     if (!item.isOk || item.situationRemark == '') {
      //       vaildflag = false
      //
      //     }
      //   })
      // }
      // if (!vaildflag) {
      //   this.$message.warning('请先完成见证情况登记')
      //   return
      // }

      this.dialogVisible = true;
      this.auditForm.suggest = msg;
      this.auditForm.isPass = isPass;
    },

    expertPush() {
      const { evalcommitteeBuildId, tenderCode } = this.$route.query
      const dateCode = this.paramMap.datasetCode || ''
      if (!evalcommitteeBuildId || !tenderCode || !dateCode) {
        this.$message.error('推送参数无效')
        return
      }
      this.$http.post(`/expertController/push?evalcommitteeBuildId=${evalcommitteeBuildId}&tenderCode=${tenderCode}&dateCode=${dateCode}`).then(res => {
        const { code } = res.data
        if (code == 1) {
          this.$message.success('推送成功')
        } else {
          this.$message.error(res.data.msg || '推送失败')
        }
      })
    },

    // 见证
    auditProcess() {
      this.loading = true;
      this.$http.post('/businessFlowWitness/processSubmit', {
        id: this.id,
        taskId: this.taskId,
        businessType: this.businessType,
        processinstanceid: this.processinstanceid,
        variables: {
          commit: this.auditForm.isPass,
          opinion: this.auditForm.suggest //见证意见
        },
        entityId: this.entityId,
        personHandle: this.form.personHandle,  //1:人工干预见证
      }).then(res => {
        this.loading = false;
        this.dialogVisible = false;

        if (res.data.code == 1) {

          this.$message({
            type: 'success',
            message: '操作成功。'
          })

          this.processSubmit = false;
          this.filingCBtn = false;
          this.backCBtn = false;

          this.getFlow(this.processinstanceid)
          this.getAuditHisList()

          // if (this.$refs.witnessStatusForm.submitCallback) {
          //   this.$refs.witnessStatusForm.submitCallback();
          // }


          // 此处对交易数据预警里面的预警项进行处理或者忽略操作
          var opinion = this.auditForm.isPass ? '在项目见证受理时，对该数据执行同意操作' : '在项目见证受理时，对该数据执行退回操作';
          var historyId = this.auditForm.isPass ? 1 : 0;
          var params = {
            entityId: this.entityId,
            opinion: this.auditForm.isPass ? '在项目见证受理时，对该数据执行同意操作' : '在项目见证受理时，对该数据执行退回操作',
            historyId: this.auditForm.isPass ? 1 : 0,
          };
          this.$http.get(`/jzWarnRecords/handleByEntityId?entityId=${this.entityId}&opinion=${opinion}&historyId=${historyId}`).then(res => {
            if (res.data.code == 1) {
              this.$message({
                type: 'success',
                message: res.data.msg
              })
            }
          })



        } else {
          this.$message({
            type: 'error',
            message: res.data.msg || '流程提交失败。'
          })
        }

      })
    },



    //获取流程
    getFlow(id) {
      this.$http.get(`/workflow/getInfo?processInstanceid=${id}`).then(res => {
        if (res.data.data.taskId !== '') {
          this.taskId = res.data.data.taskId;

          res.data.data.buttons.forEach(item => {

            if (item.type == 1) {
              this.processSubmit = true;
            }
            if (item.type == 2) {
              this.filingCBtn = true
            }
            if (item.type == 3) {
              this.backCBtn = true
            }
            if (item.type === 10) {
              this.backCBtn = true
              this.filingCBtn = true
            }
          })

        }


      }).catch(e => {

      })
    },



    getFormIdByFlowid(flowid) {
      // 根据jz_businessflow_witness的formid得到sys_flownode_config的form_id
      this.$http.get('/configs/sysFlowNodeConfig/get?id=' + flowid).then(res => {
        if (res.data.code === '1') {
          this.categoryCode = res.data.data.categoryCode;
          this.paramMap.categoryCode = res.data.data.categoryCode;
          this.nodeCode = res.data.data.nodeCode;
          this.nodeTitle = res.data.data.nodeName;
          this.paramMap.categoryIsOpen = res.data.data.categoryIsOpen;
          this.paramMap.datasetCode = res.data.data.datasetCode || '';
          this.paramMap.categoryCode = res.data.data.categoryCode;
          if (res.data.data.enableCustom == 1) {
            this.customFormShow = true;
            this.customFormOtherShow = false;
          } else {
            this.customFormShow = false;
            this.customFormOtherShow = true;
          }
          this.initData(res.data.data.formId);
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }

      })
    },




    // 获取自定义表单或定制化表单数据
    initData(formid) {



      // 支持自定义表单数据
      if (this.customFormShow) {
        if (formid == '' || formid === undefined) {
          this.$message.error('数据集无效')
          return
        }
        const that = this;
        setTimeout(function () {
          that.$refs.customFormRef.getCustomData(formid, that.paramMap);
        }, 100)

      }
      if (this.customFormOtherShow) { // 定制化表单数据
        const that = this;
        setTimeout(function () {
          that.$refs.customFormOtherRef.getCustomData(formid, that.paramMap, that.nodeCode, that.purchaserMode);
        }, 100)
      }



    },





  },
  deactivated() {
  },





}
</script>

<style lang="less" scope>
.right-content.busWinessRight {
  width: calc(100% - 160px);
}

.left-content.busWinessLeft {
  .left-navbar {
    width: 150px;
    border: none;
  }
}
</style>
